<app-tabla
  [totalCount]="totalCount"
  [datos]="luminarias"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [exportar]="[botonExportar, botonImportar]"
  [filtros]="filtros"
  [emptyState]="{
    title: 'Todavía no hay luminarias',
    subtitle: 'Las luminarias que crees o importes aparecen acá.',
  }"
></app-tabla>
